module.exports = __webpack_public_path__ + "img/loudong.f8e9c138.png";